import {cs}                              from "@Common/react/chain-services";
import {consumeContext, provideContext1} from "@Common/react/context";
import {Static}                          from "@Common/react/static";
import {cache0}                          from "@Common/utils/cache0";
import {cache1}                          from "@Common/utils/cache1";
import {chain}                           from "@Common/utils/fs";

export const loadProofImgsCache = ({next}) => cs(
    consumeContext("ccApis"),
    ["proofImgsCache", ({ccApis}, next) => Static({
        getInitValue: () => cache1((templateId, {customization}) => {
            let loaded = null;
            return ({
                getLoaded: () => loaded,
                load: cache0(async () => {
                    const fields = await ccApis.getTemplateFields({templateId});
                    // console.log("fields", fields);
                    // console.log("customization", customization)

                    const ret = await ccApis.getHighResProducts1({
                        templateId,
                        variableData: getVariableData({fields, customization}),
                    });
                    loaded = ret;
                    return ret;
                }),
            });
        }),
        next,
    })],
    ({proofImgsCache}) => provideContext1("proofImgsCache", proofImgsCache, next),
);

const getVariableData = ({fields, customization}) => {
    return chain(
        fields,
        (_) => _.map(({name, type, sequence}) => {
            if (type === "image") {
                const src = customization.headshots?.[sequence - 1] ?? customization.headshots?.[0];
                if (src) {
                    return {
                        name,
                        "type": "image",
                        "value": src,
                    };
                }
            } else {
                // return {
                //     "name": "Phone1",
                //     "type": "text",
                //     "value": "88888888888"
                // };
            }
        }),
        (_) => _.filter(v=>v),
    );
    // return [
    //     {
    //         "name": "Photo01",
    //         "type": "image",
    //         "value": customization.headshots[0],
    //     },
    //     {
    //         "name": "Phone1",
    //         "type": "text",
    //         "value": "88888888888"
    //     }
    // ];
};


const sampleFields = [
    {
        "name": "Phone1",
        "surfaceName": "Front",
        "type": "text",
        "contentType": "",
        "sequence": 0
    },
    {
        "name": "License",
        "surfaceName": "Back",
        "type": "text",
        "contentType": "",
        "sequence": 0
    },
    {
        "name": "Photo01",
        "surfaceName": "Back",
        "type": "image",
        "contentType": "photo",
        "sequence": 1
    },
    {
        "name": "BranchInfo",
        "surfaceName": "Back",
        "type": "text",
        "contentType": "",
        "sequence": 0
    },
    {
        "name": "LockedPhoto",
        "surfaceName": "Back",
        "type": "shape",
        "contentType": "",
        "sequence": 0
    }
];
